import Loader from 'components/common/loading/Loader';

function ForecastDailyLoader() {
  return (
    <div data-testid="forecast-daily-loader">
      {/* Button bar */}
      <Loader className="mb-3 h-9" />

      {/* Day of week */}
      <Loader className="mb-1 h-7 w-24" />

      {/* Icon and temps */}
      <Loader className="mb-1 h-16" />

      {/* Conditions text */}
      <Loader className="mb-1 h-7 w-32" />

      {/* Precipitation */}
      <Loader className="mb-12 h-6 w-40" />

      {/* Hourly conditions */}
      <Loader className="mb-12 h-44" />

      {/* Sunrise and sunset */}
      <Loader className="mb-3 h-11" />

      {/* Length of day */}
      <Loader className="mb-3 h-5 w-40" />

      {/* Daylight remaining */}
      <Loader className="mb-3 h-5 w-40" />
    </div>
  );
}
export default ForecastDailyLoader;
